import { render } from "./FollowUp.vue?vue&type=template&id=082b42ac&scoped=true"
import script from "./FollowUp.vue?vue&type=script&lang=js"
export * from "./FollowUp.vue?vue&type=script&lang=js"

import "./FollowUp.vue?vue&type=style&index=0&id=082b42ac&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2367962886/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082b42ac"]])

export default __exports__